import Vue from "vue";
import Vuex from "vuex";
import files from "./modules/files";
import axios from "axios"
import {prepareTokenForStore, editFunctionality} from "@/utils/authHelper";
import {STORED_TOKEN_KEY_NAME} from "../utils/constants";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    files,
  },
  state: {
    user: null,
    isAdmin: false
  },
  getters: {
    user: (s) => s.user,
    isAdmin: (s) => s.isAdmin
  },
  mutations: {
    login(state, user) {
      state.user = user
    },
    setUserToken(state, data) {
      state.user = data
    },
    setAdmin(state, data) {
      state.isAdmin = data
    },
    logout(state) {
      state.user = null
    },
  },
  actions: {
    login(context, data) {
      return new Promise((resolve, reject) => {
        context.commit('logout');
        const reqData = 'client_id=shottrackerteamapp&username=' + data.username + '&password=' + data.password + '&grant_type=password'
        axios.post(process.env.VUE_APP_TOKEN_URL, reqData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'Accept': 'application/json'
          }
        }).then(response => {
          const user = response.data;
          const userData = prepareTokenForStore(user)
          const isAdmin = editFunctionality(user.roles)
          context.commit('setAdmin', isAdmin)
          //localStorage.setItem(storageKey('user'), JSON.stringify(userData))
          console.log(user, userData)
          this._vm.$storageService.setItem(STORED_TOKEN_KEY_NAME, JSON.stringify(userData))

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token
          context.commit('login', user)
          resolve(user)
        }).catch(error => {
          console.warn(error);
          context.commit('logout')
          this._vm.$storageService.removeItem(STORED_TOKEN_KEY_NAME) //TODO storageService handler
          reject(error)
        })
      })
    },
    logout(context) {
      return new Promise((resolve) => {
        context.commit('logout')
        this._vm.$storageService.removeItem(STORED_TOKEN_KEY_NAME)
        delete axios.defaults.headers.common['Authorization']
        if (process.env.VUE_APP_ENV !== 'production') {
          resolve()
        } else {
          window.location.href = process.env.VUE_APP_LOGOUT_URL
        }
        //resolve();
      });
    },
    refresh(context) {
      console.log('refresh credentials')
      return new Promise((resolve, reject) => {
        const stToken = this._vm.$storageService.getItem(STORED_TOKEN_KEY_NAME) || {}
        if (stToken.refresh_token) {
          delete axios.defaults.headers.common['Authorization'];
          const reqData = 'client_id=shottrackerteamapp&refresh_token=' + stToken.refresh_token + '&grant_type=refresh_token';
          // const url = buildApiUrl(process.env.VUE_APP_API_URL, '/oauth/token')
          return axios.post(process.env.VUE_APP_TOKEN_URL, reqData)
            .then(response => {
              const user = response.data
              const userData = prepareTokenForStore(user)
              const isAdmin = editFunctionality(user.roles)
              context.commit('setAdmin', isAdmin)
              if (userData.refresh_token) {
                this._vm.$storageService.setItem(STORED_TOKEN_KEY_NAME, JSON.stringify(userData))
              }
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token
              context.commit('login', user)
              resolve(response)
            })
            .catch(error => {
              context.dispatch('logout')
              reject(error)
            })
        }
        resolve()
      })
    }
  }
});
